<template>
  <section class="core" name="core">
    <div class="container">
      <!--<a-typography-title :level="1">-->
      <!--  <span>三大核心产品</span>-->
      <!--  <template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)">，</template>-->
      <!--  <br v-else />-->
      <!--  <span>高效构建Serverless基础架构</span>-->
      <!--</a-typography-title>-->
      <div v-for="(item,index) in expand.core"
           class="item" :class="`i_${index+1}`">
        <a-row>
          <a-col class="box_content" :xs="24" :md="12"
                 :order="index%2===0&&$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?1:2">
            <a-typography>
              <div v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)"
                   class="image" />
              <a-typography-title :level="2">
                {{ item.title_en }}
              </a-typography-title>
              <a-typography-title :level="3">
                {{ item.title }}
              </a-typography-title>
              <a-typography-paragraph>
                {{ item.text }}
              </a-typography-paragraph>
              <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
                <a-button v-if="item.clickMore"
                          type="link" class="button_n_2" target="_blank"
                          @click="item.clickMore">
                  了解更多
                </a-button>
                <!--<a-button v-if="item.clickFree"-->
                <!--          type="link" class="button_n_3" target="_blank"-->
                <!--          @click="item.clickFree">-->
                <!--  免费体验-->
                <!--</a-button>-->
              </a-space>
            </a-typography>
          </a-col>
          <a-col class="box_image" :xs="0" :md="12"
                 :order="index%2!==0&&$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?1:2">
            <div class="image" />
          </a-col>
        </a-row>
        <!--<HomeVideo v-if="index===expand.core.length-1" />-->
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import HomeVideo from '@template/page/home/homeVideo.vue';

export default {
  name: 'home_core',
  components: {
    HomeVideo
  },
  data(): DataInterface {
    return {
      expand: {
        core: [
          // {
          //   title_en: 'Serverless平台InfraPilot',
          //   title: '打造企业专属的Serverless平台',
          //   text: '基于多项专利技术的全链路Serverless平台，无需改造即可完成各种语言及框架的Serverless化，' +
          //     '实现分钟级应用部署、无人化运维保障、自动化成本治理，一站式管理企业内各类开源、自研、商业化应用，' +
          //     '打造智能高效的企业云操作系统，大幅提升部署运维效率。',
          //   clickMore: () => {
          //     this.$router.push($Enum.RouterEnum.ProductInfraPilot);
          //   },
          //   clickFree: () => {
          //     open($Config.Href.cloud);
          //   }
          // },
          // {
          //   title_en: 'CostPilot',
          //   title: '云原生FinOps平台',
          //   text: '一站式全场景企业云成本管家，覆盖成本洞察、成本优化等成本管理全流程，提供针对性的优化方案，' +
          //     '更有高级优化功能帮助方案快速落地，助力企业IT成本优化最高50%以上。',
          //   clickMore: () => {
          //     this.$router.push($Enum.RouterEnum.ProductCostPilot);
          //   },
          //   clickFree: () => {
          //     $Store.Page().openModal('modalFormCollection', 'freeUseCostPilot');
          //   }
          // },
          // {
          //   title_en: 'SchedulX',
          //   title: '云原生智能运维平台',
          //   text: '具备先进Serverless能力的智能运维平台，帮助基于任意语言开发的Web系统在零代码改造的前提下实现Serverless化，' +
          //     '通过全自动化部署发布、性能维护、稳定性治理，减少90%以上的运维工作，整体IT成本节省可达60%以上。',
          //   clickMore: () => {
          //     this.$router.push($Enum.RouterEnum.ProductSchedulX);
          //   },
          //   clickFree: () => {
          //     $RQ.GoGSS();
          //   }
          // }
          {
            title_en: '下一代Serverless技术驱动的',
            title: '星汉未来AI应用平台——AIPilot',
            text: '轻松管理不断涌现的AI应用与大模型，统一调度云端及本地的GPU、CPU等计算资源。' +
                  'AIPilot支持大型模型推理，并已对接八家以上大模型厂商API，助力企业快速、高效、低成本的将AI融入多元生产场景。' +
                  '基于众多专利技术，AIPilot能在一台8核16G的笔记本电脑上部署20个热门AI应用，企业只需万元成本，即可构建专属的AI应用引擎。',
            clickMore: () => {
              this.$router.push($Enum.RouterEnum.ProductAIPilot);
            },
            clickFree: () => {
              // location.href = $Config.Href.cloud;
              open($Config.Href.cloud);
            }
          },
          {
            title_en: 'InfraPilot',
            title: '星汉未来AI托管平台',
            text: '依托多项专利技术，无需改造即可实现AI应用与大模型推理的Serverless化。' +
                  'InfraPilot支持分钟级应用部署、GPU/CPU自动调度、无人化运维以及自动化成本治理。' +
                  '一站式管理企业内各类自研AI应用与大模型，构建高效的AI应用开发及大模型训练推理平台，显著提升研发效率。',
            clickMore: () => {
              this.$router.push($Enum.RouterEnum.ProductInfraPilot);
            },
            clickFree: () => {
            }
          },
          {
            title_en: '基于先进AI Agent的',
            title: '实时交互数字人',
            text: '星汉未来实时交互数字人产品基于AI大模型、RAG、Agent等多种领先技术打造智慧大脑，' +
                  '比传统知识库类型数字人更加智慧，支持实时语音/文字/图像多模态交互系统，' +
                  '并适配了多种尺寸、各种型号的硬件设备。',
            clickMore: () => {
              this.$router.push($Enum.RouterEnum.ProductAidigitalHuman);
            },
            clickFree: () => {
            }
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/home/';

.creatAnimation(am_core, {
  0% {
    .transform(translate(-50%, -50%));
  }
  50% {
    .transform(translate(-50%, calc(~'-50% - 10px')));
  }
  100% {
    .transform(translate(-50%, -50%));
  }
});

.core {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.item {
  overflow: hidden;
  position: relative;
  padding: @space 0;
  
  &:last-child {
    &::before {
      display: none;
    }
  }
  
  .loop(@i) when (@i<=3) {
    &.i_@{i} {
      .image {
        &::before {
          .bg('@{image}core_image_@{i}_bg.png', 750px, 400px, true);
        }
        
        &::after {
          .bg('@{image}core_image_@{i}.png', 400px, 360px, true);
          .animation(am_core 5s 1s*(-1+@i) ease infinite forwards);
        }
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &.i_1 {
    .image {
      &::after {
        top: calc(~'50% - 10px');
        left: calc(~'50% + 20px');
      }
    }
  }
  
  &.i_2 {
    .image {
      &::after {
        top: calc(~'50% - 0px');
        left: calc(~'50% + 15px');
      }
    }
  }
  
  &.i_3 {
    .image {
      &::after {
        top: calc(~'50% - 10px');
        left: calc(~'50% + 15px');
      }
    }
  }
  
  &::before {
    content: '';
    display: block;
    .position(bottom);
    z-index: 5;
    height: 2px;
    .bg('@{src_image}/page/public/border_dotted_h.png', auto, 2px);
    background-repeat: repeat-x;
    background-position: 0 0;
  }
  
  .box_content {
    position: relative;
    z-index: 1;
  }
  
  .box_image {
    position: relative;
    z-index: 0;
  }
  
  article.ant-typography {
    position: relative;
    
    > .image {
      .position(absolute, -90px, 60px, auto, auto);
      z-index: -1;
      .transform(scale(0.25));
    }
    
    h2.ant-typography {
      margin: 0;
      .font(justify, @title_sub, @color_6, @title_sub);
      
    }
    
    h3.ant-typography {
      margin: @margin_mo 0 0;
      .font(justify, @title_sub, @color_12, @title_sub, true);
    }
    
    div.ant-typography {
      margin: @margin 0 0;
      .font(justify, @text+@line+5px, @color_13, @text);
    }
    
    .ant-space {
      margin: @margin 0 0;
    }
  }
  
  .image {
    position: relative;
    min-height: 100%;
    .transform(scale(0.9));
    pointer-events: none;
    
    &::before,
    &::after {
      content: '';
      display: block;
      .position(absolute, 50%, auto, auto, 50%);
      .transform(translate(-50%, -50%));
    }
    
    &::before {
      top: calc(~'50% + 70px');
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .core {
    .container {
      padding: @space_mo 0 0;
    }
  }
  
  h1.ant-typography {
    margin: 0;
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .item {
    padding: 20px 0;
    
    article.ant-typography {
      h2.ant-typography {
        .font(justify, @title_sub_mo, @color_6, @title_sub_mo);
      }
      
      h3.ant-typography {
        margin: @margin_mo 0 0;
        .font(justify, @title_sub_mo, @color_12, @title_sub_mo, true);
      }
      
      div.ant-typography {
        margin: @margin_mo 0 0;
        .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
      }
      
      .ant-space {
        margin: @margin_mo 0 0;
      }
    }
    
    .image {
      min-height: 250px;
      .transform(scale(0.6));
    }
  }
}
</style>